<template>
  <div class="menu-wrapper" v-if="$store.state.shop.open_shop_step_info.step_progress_complete">
    <template v-for="item in routes">
      <div v-if="!item.hidden&&item.children" :key="item.path">
        <router-link
          v-if="item.children.length===1 && !item.children[0].children"
          :to="item.path+'/'+item.children[0].path"
          :key="item.children[0].name"
        >
          <el-menu-item
            :index="item.path+'/'+item.children[0].path"
            class="submenu-title-noDropdown"
          >
            <svg-icon
              v-if="item.children[0].meta&&item.children[0].meta.icon"
              :icon-class="item.children[0].meta.icon"
            ></svg-icon>
            <span
              v-if="item.children[0].meta&&item.children[0].meta.title"
            >{{generateTitle(item.children[0].meta.title)}}

              <!-- sidebar notification -->
              <el-badge :is-dot="item.children[0].meta.badge&&item.children[0].meta.badge=='dot'" :value="item.children[0].meta.badge"  class="item"></el-badge>
            </span>
          </el-menu-item>
        </router-link>

        <el-submenu v-else :index="item.name||item.path" :key="item.name">
          <template slot="title">
            <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
            <span v-if="item.meta&&item.meta.title">
              {{generateTitle(item.meta.title)}}
              <!-- sidebar notification -->
              <el-badge v-if="item.badge&&item.badge=='dot'" is-dot class="item"></el-badge>
              <el-badge v-else-if="item.badge" :value="item.badge" class="item"></el-badge>
            </span>
            <!-- <span v-if="item.meta.title === 'agent'" style="color: red; font-size: 13px;">Beta 1.0</span> -->
          </template>

          <template v-for="child in item.children">
            <div v-if="!child.hidden" :key="child.pat">
              <sidebar-item
                class="nest-menu"
                v-if="child.children&&child.children.length>0"
                :routes="[child]"
                :key="child.path"
              ></sidebar-item>

              <router-link v-else :to="item.path+'/'+child.path" :key="child.name">
                <el-menu-item :index="item.path+'/'+child.path">
                  <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
                  <span v-if="child.meta&&child.meta.title">
                    {{generateTitle(child.meta.title)}}
                    <!-- sidebar notification -->
                    <el-badge :is-dot="child.meta.badge&&child.meta.badge=='dot'" :value="child.meta.badge" class="item"></el-badge>
                  </span>
                </el-menu-item>
              </router-link>
            </div>
          </template>
        </el-submenu>
      </div>
    </template>
  </div>
  <div class="menu-wrapper" v-else>
    <template v-for="item in routes">
      <div v-if="!item.hidden&&item.children" :key="item.path">
        <el-menu-item
            v-if="item.children.length===1 && !item.children[0].children"
            :index="item.path+'/'+item.children[0].path"
            class="submenu-title-noDropdown"
            :key="item.children[0].name"
            disabled
          >
            <svg-icon
              v-if="item.children[0].meta&&item.children[0].meta.icon"
              :icon-class="item.children[0].meta.icon"
            ></svg-icon>
            <span
              v-if="item.children[0].meta&&item.children[0].meta.title"
            >
              {{generateTitle(item.children[0].meta.title)}}
              <!-- sidebar notification -->
              <el-badge v-if="item.children[0].badge&&item.children[0].badge=='dot'" is-dot class="item"></el-badge>
              <el-badge v-else-if="item.children[0].badge" :value="item.children[0].badge" class="item"></el-badge>
            </span>
          </el-menu-item>

        <el-submenu v-else :index="item.name||item.path" :key="item.name" disabled>
          <template slot="title">
            <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
            <span v-if="item.meta&&item.meta.title">
              {{generateTitle(item.meta.title)}}
              <!-- sidebar notification -->
              <el-badge v-if="item.badge&&item.badge=='dot'" is-dot class="item"></el-badge>
              <el-badge v-else-if="item.badge" :value="item.badge" class="item"></el-badge>
            </span>
            <!-- <span v-if="item.meta.title === 'agent'" style="color: red; font-size: 13px;">Beta 1.0</span> -->
          </template>

          <template v-for="child in item.children">
            <div v-if="!child.hidden" :key="child.pat">
              <sidebar-item
                class="nest-menu"
                v-if="child.children&&child.children.length>0"
                :routes="[child]"
                :key="child.path"
              ></sidebar-item>
              <el-menu-item v-else :index="item.path+'/'+child.path" :key="child.name">
                <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
                <span v-if="child.meta&&child.meta.title">
                  {{generateTitle(child.meta.title)}}
                  <!-- sidebar notification -->
                  <el-badge v-if="child.badge&&child.badge=='dot'" is-dot class="item"></el-badge>
                  <el-badge v-else-if="child.badge" :value="child.badge" class="item"></el-badge>
                </span>
              </el-menu-item>
            </div>
          </template>
        </el-submenu>
      </div>
    </template>
  </div>
</template>

<script>
import { generateTitle } from '@/utils/i18n'

export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    }
  },
  methods: {
    generateTitle
  }
}
</script>
